/* News hub: progressive enhancement only. Every link works without this file.
   - "Show N more": reveals the server-rendered rows 12 (desktop) / 8 (mobile) at a time, then lets
     the link through to the next page.
   - Filters in place: game chips, category tabs, tiles and "Clear filters" fetch the target page's
     section through Shopify's Section Rendering API and swap it in, with a real URL in history. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mcc-hub]');
  if (!root) return;
  var mobile = window.matchMedia('(max-width: 989px)');
  function step() { return mobile.matches ? 8 : 12; }

  function label(btn, left) {
    var n = Math.min(step(), left);
    var real = btn.getAttribute('href') && btn.getAttribute('href') !== '#';
    if (left > 0) {
      btn.textContent = 'Show ' + n + ' more';
      btn.hidden = false;
    } else if (real) {
      btn.textContent = 'Older articles';
      btn.hidden = false;
    } else {
      btn.hidden = true;
    }
    btn.classList.remove('d-none', 'm-none');
  }

  function initFeeds(scope) {
    scope.querySelectorAll('[data-feed]').forEach(function (feed) {
      var rows = feed.querySelectorAll('.fr'), n = step();
      rows.forEach(function (r, i) {
        r.hidden = i >= n;            // same state the CSS already showed: no layout shift
        r.classList.remove('mx', 'dx');
      });
      feed._shown = Math.min(n, rows.length);
      var btn = feed.parentNode.parentNode.querySelector('[data-more]');
      if (btn && !btn._feed) { btn._feed = feed; label(btn, rows.length - feed._shown); }
    });
  }

  function reveal(btn) {
    var feed = btn._feed;
    if (!feed) return false;
    var rows = feed.querySelectorAll('.fr');
    var left = rows.length - feed._shown;
    if (left <= 0) return false;
    var end = Math.min(rows.length, feed._shown + step());
    for (var i = feed._shown; i < end; i++) rows[i].hidden = false;
    feed._shown = end;
    label(btn, rows.length - end);
    return true;
  }

  // keep the active chip and tab visible inside their horizontal scrollers (mobile)
  function showActive(scope) {
    scope.querySelectorAll('.chips .chip.on, .tabs .tab.on').forEach(function (el) {
      var box = el.parentNode, b = box.getBoundingClientRect(), r = el.getBoundingClientRect();
      if (r.left < b.left || r.right > b.right) box.scrollLeft += r.left - b.left - 16;
    });
  }

  var busy = null;
  function go(url, push) {
    var u = new URL(url, location.href);
    u.searchParams.set('section_id', root.getAttribute('data-section'));
    if (busy) busy.abort();
    busy = window.AbortController ? new AbortController() : null;
    root.classList.add('is-loading');
    fetch(u.toString(), { credentials: 'same-origin', signal: busy ? busy.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mcc-hub]');
        if (!next) throw new Error('no hub');
        root.innerHTML = next.innerHTML;
        var t = next.getAttribute('data-title');
        if (t) { root.setAttribute('data-title', t); document.title = t; }
        if (push) history.pushState({ mccHub: 1 }, '', url);
        initFeeds(root);
        showActive(root);
        root.classList.remove('is-loading');
        var bar = root.querySelector('.gamebar');
        if (bar) {
          var top = bar.getBoundingClientRect().top + window.pageYOffset;
          if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
        }
        busy = null;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        location.href = url;           // fall back to a normal page load
      });
  }

  document.addEventListener('click', function (ev) {
    if (ev.defaultPrevented || ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var a = ev.target.closest && ev.target.closest('a');
    if (!a || !root.contains(a)) return;
    if (a.hasAttribute('data-more')) {
      if (reveal(a) || a.getAttribute('href') === '#') ev.preventDefault();
      return;
    }
    if (a.hasAttribute('data-hub-nav') && window.fetch && window.DOMParser && window.URL) {
      ev.preventDefault();
      go(a.href, true);
    }
  });

  window.addEventListener('popstate', function (ev) {
    if (ev.state && ev.state.mccHub) go(location.href, false);
  });
  if (window.history && history.replaceState) history.replaceState({ mccHub: 1 }, '');
  initFeeds(root);
  showActive(root);
})();
